import React, { useEffect, useMemo } from "react"
import { motion } from "framer-motion"
import { Outlet } from "react-router-dom"
import { twMerge } from "tailwind-merge"

import Sidebar from "./Sidebar"
import Header from "./Header"
import { useAuthStore, useLegacyStore } from "@src/store"
import { useMediaQuery, useInitializeData } from "@src/hooks"
import { BREAKPOINTS } from "@src/utils"

const Layout: React.FC = () => {
  const getProfiles = useLegacyStore((state) => state.getProfiles)
  const isLoading = useAuthStore((state) => state.isLoading)
  const me = useAuthStore((state) => state.me)

  const isMobile = useMediaQuery(`(max-width: ${BREAKPOINTS.SM})`)

  useInitializeData()

  useEffect(() => {
    getProfiles().then(() => {})
    me().then(() => {})
  }, [])

  const mainHeight = useMemo(
    () => (isMobile ? "h-[calc(100vh-49.75px)]" : "h-[calc(100vh-61.2305px)]"),
    [isMobile],
  )

  return (
    <>
      {isLoading && (
        <div className="min-h-screen flex items-center justify-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-legacy-blue"></div>
        </div>
      )}
      <div className={twMerge("min-h-screen bg-[#F1F1F1] dark:bg-slate-950", !isMobile && "flex")}>
        <Sidebar isMobile={isMobile} />
        <div className={twMerge("transition-all duration-300", !isMobile && "flex-1")}>
          <Header isMobile={isMobile} />
          <motion.main
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={twMerge("main box-border p-4 h-full lg:p-6 overflow-y-auto", mainHeight)}
          >
            <Outlet />
          </motion.main>
        </div>
      </div>
    </>
  )
}

export default Layout
